<template>
  <div class="form-field">
    <div
      class="input-container"
      :class="{ highlighted: isFocused, hasError: input.hasError }"
    >
      <label
        class="textarea-label"
        :for="inputKey"
        :data-content="input.title"
      >
        <span v-html="lang[activeLang][input.title] || input.title"></span>
        <!--<em v-if="input.required">*</em>-->
        <span v-if="input.charlimit" class="char-count-label">Remaining characters: <span class="char-count-number">{{ remainingCount }}</span> (which is approximately 300 to 400 words in English, including spaces)</span>
        <span v-if="input.sublabel" class="char-count-sublabel">{{ lang[activeLang][input.sublabel] || input.sublabel }}</span>
      </label>
      <textarea
        :id="inputKey"
        v-model="message"
        type="text"
        :placeholder="input.title"
        class="float__textarea"
        :class="{ hasError: input.hasError }"
        :maxlength="input.charlimit"
        @input="inputUpdate(input, $event.target.value)"
        @focus="isFocused = true"
        @blur="isFocused = false"
      />
    </div>
    <label
      v-if="input.hasError && input.requiredError"
      class="error-text"
    >
      {{ lang[activeLang]['This field is required.'] }}</label>
    <label
      v-else-if="input.hasError && input.errorMsg"
      class="error-text"
    >{{
      input.errorMsg
    }}</label>
  </div>
</template>

<script>
export default {
  name: 'FormTextArea',
  props: {
    formData: {
      type: Object,
      default: new Object()
    },
    activeLang: {
      type: String,
      default: 'English'
    },
    input: {
      type: Object,
      required: true
    },
    inputKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      remainingCount: null,
      message: String,
      isFocused: false
    }
  },
  created() {
    this.message = this.formData[this.input.index] || null
    this.remainingCount = this.input.charlimit || null
    if (this.message && this.input.charlimit) {
      this.remainingCount = this.input.charlimit - this.message.length
    }
  },
  methods: {
    inputUpdate: function(input, newVal) {
      // Update the remaining characters if there's a character limit in place.
      if (input.charlimit) {
        this.remainingCount = this.remainingCount || input.charlimit
        this.remainingCount = input.charlimit - newVal.length
      }

      // Send the new value up to the parent.
      this.$emit('formUpdate', newVal)

      // If there's no error, don't perform a valid check to see if it has updated.
      if (!input.hasError) return

      // If the length increases, then it's no longer empty and we'll remove the requiredError.
      if (newVal.length > 0) {
        input.requiredError = false
      }

      // If it had a valid error we'll validate one more time.
      if (input.errorMsg && input.isValid && input.isValid(newVal)) {
        input.errorMsg = null
      }

      // If there's no validation or required error we remove the hasError property.
      if (!input.errorMsg || input.requiredError) {
        input.hasError = false
      }
    }
  }
}
</script>

<style scoped>
.input-container.input-field {
  padding-top: 0;
}

.form-field {
  width: 100%;
}

.input-container {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  /*padding-top: .5em; */
  position: relative;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px;
  outline-width: 1px;
  border-style: solid;
  border-color: #d4d6de;
  display: flex;
  flex-direction: column;
}

.highlighted {
  border-color: #9cbaf2;
}

.highlighted label {
  color: #6693D1;
}

.highlighted .textarea-label,
.highlighted .char-count-label,
.highlighted .char-count-sublabel {
  color: rgb(102, 102, 102);
}

.highlighted .char-count-number {
  color: rgb(214, 88, 88);
}

.float__textarea {
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 1em;
  caret-color: #9cbaf2;
  padding: 1em;
  font-size: 16px;
  min-height: 10rem;
  resize: vertical;
}

.float__textarea::placeholder {
  color: rgba(0, 0, 0, 0);
}

.textarea-label {
  margin: 1em;
  color: rgb(102, 102, 102);
  content: attr(data-content);
  filter: blur(0);
  backface-visibility: hidden;
  pointer-events: none;
  display: block;
  background: #fff;
  transition: all 0.2s ease;
  text-align: left;
}

.char-count-label {
  display: block;
  margin-top: 4px;
  font-style: normal;
  color: rgb(102, 102, 102);
}

.char-count-number {
  color: rgb(214, 88, 88);
}

.char-count-sublabel {
  display: block;
  margin-top: 4px;
  font-style: normal;
  color: rgb(102, 102, 102);
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

.error-text {
  color: rgb(214, 88, 88);
  text-align: left;
  font-size: 12px;
  padding-top: 4px;
  float: left;
}

.hasError {
  border-color: rgb(214, 88, 88);
}
</style>
